import React, { FC } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface NgDividerProps {
  vertical?: boolean;
  minHeight?: number;
  spacing?: 'small' | 'medium' | 'large';
}

const StyledDivider = styled.hr<{ $minHeight: number, $spacing: string }>`
  border: 1px solid ${({theme}) => theme.palette.stroke};
  margin: ${({theme, $spacing}) => theme.spacing[$spacing]} 0;

  &.vertical {
    height: ${({$minHeight}) => `${$minHeight}px` || '100%'};
    width: 1px;
    margin: 0 ${({theme, $spacing}) => theme.spacing[$spacing]};
  }

  height: 1px;
  width: 100%;
`;

export const NgDivider: FC<NgDividerProps> = ({ vertical = false, minHeight = 30, spacing = 'medium' }) => {
  return <StyledDivider className={classNames({ vertical: vertical })} $spacing={spacing} $minHeight={minHeight} />;
};
